import React, { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";

import {
  FaFileCsv,
  FaFileExcel,
  FaFilePdf,
} from "react-icons/fa";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./ReportsExports.css";

function ReportsExports() {
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    fetchAssets();
  }, []);

  const fetchAssets = async () => {
    try {
      const data = await apiClient(
        "/assets/list/"
      );

      const assetList = Array.isArray(data)
        ? data
        : data?.results || data?.assets || [];

      setAssignments(assetList);
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  };

  /* ===============================
      FILTER DATA
  =============================== */

  const activeAssignments = assignments.filter(
    (item) => item.status === "Active"
  );

  const returnedLaptops = assignments.filter(
    (item) => item.status === "Returned"
  );

  const replacementHistory = assignments.filter(
    (item) =>
      item.status === "Returned" ||
      item.status === "Reassigned"
  );

  const fullHistory = assignments;

  const reports = [
    {
      title: "Active Assignments",
      subtitle: "All laptops currently in use",
      count: activeAssignments.length,
      data: activeAssignments,
    },
    {
      title: "Returned Laptops",
      subtitle: "Available for redeployment",
      count: returnedLaptops.length,
      data: returnedLaptops,
    },
    {
      title: "Replacement History",
      subtitle:
        "All returned / reassigned records",
      count: replacementHistory.length,
      data: replacementHistory,
    },
    {
      title: "Full History",
      subtitle:
        "Every assignment record across all employees",
      count: fullHistory.length,
      data: fullHistory,
    },
  ];

  /* ===============================
      CSV EXPORT
  =============================== */

  const exportCSV = (records, fileName) => {
    if (!records.length) {
      alert("No records found");
      return;
    }

    const headers = Object.keys(records[0]);

    const csvRows = [
      headers.join(","),
      ...records.map((row) =>
        headers
          .map(
            (field) =>
              `"${row[field] ?? ""}"`
          )
          .join(",")
      ),
    ];

    const blob = new Blob(
      [csvRows.join("\n")],
      { type: "text/csv" }
    );

    const url =
      window.URL.createObjectURL(blob);

    const link =
      document.createElement("a");

    link.href = url;
    link.download = `${fileName}.csv`;

    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  /* ===============================
      EXCEL EXPORT
  =============================== */

  const exportExcel = (
    records,
    fileName
  ) => {
    if (!records.length) {
      alert("No records found");
      return;
    }

    const worksheet =
      XLSX.utils.json_to_sheet(records);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Assets"
    );

    XLSX.writeFile(
      workbook,
      `${fileName}.xlsx`
    );
  };

  /* ===============================
      PDF EXPORT
  =============================== */

  const exportPDF = (
    records,
    fileName
  ) => {
    const doc = new jsPDF();

    if (!records.length) {
      doc.text(
        "No Records Found",
        20,
        20
      );
      doc.save(`${fileName}.pdf`);
      return;
    }

    autoTable(doc, {
      head: [Object.keys(records[0])],

      body: records.map((item) =>
        Object.values(item)
      ),

      styles: {
        fontSize: 8,
      },

      headStyles: {
        fillColor: [79, 70, 229],
      },
    });

    doc.save(`${fileName}.pdf`);
  };

  return (
    <div className="report-page">

      <div className="report-header">
        <h2>Reports & Exports</h2>

        <p>
          Download assignment data in CSV,
          Excel or PDF
        </p>
      </div>

      <div className="report-grid">
        {reports.map((item, index) => (
          <div
            className="report-card"
            key={index}
          >
            <div className="report-top">

              <div>
                <h3>{item.title}</h3>

                <p>{item.subtitle}</p>
              </div>

              <span className="record-badge">
                {item.count} records
              </span>

            </div>

            <div className="export-buttons">

              <button
                className="csv-btn"
                onClick={() =>
                  exportCSV(
                    item.data,
                    item.title
                  )
                }
              >
                <FaFileCsv />
                CSV
              </button>

              <button
                className="excel-btn"
                onClick={() =>
                  exportExcel(
                    item.data,
                    item.title
                  )
                }
              >
                <FaFileExcel />
                Excel
              </button>

              <button
                className="pdf-btn"
                onClick={() =>
                  exportPDF(
                    item.data,
                    item.title
                  )
                }
              >
                <FaFilePdf />
                PDF
              </button>

            </div>
          </div>
        ))}
      </div>

      <div className="employee-export-box">
        <h3>Employee-level Export</h3>

        <p>
          Open Employee Profile →
          Select Employee →
          Complete assignment history
          is available for export.
        </p>
      </div>

    </div>
  );
}

export default ReportsExports;